import { makeStyles } from '@material-ui/core';
import { COLORS } from 'constants/index';

export default makeStyles(() => ({
    sliderContainer: {
        '& .MuiSlider-root.Mui-disabled': {
            opacity: 0.5
        }
    },
    slider: {
        '& .MuiSlider-rail': {
            height: 7,
            color: COLORS.apariBlack10,
            borderRadius: 13
        },
        '& .MuiSlider-track': {
            height: 7,
            color: COLORS.apariLightBlue,
            borderRadius: 13
        },
        '& .MuiSlider-thumb': {
            width: 21,
            height: 21,
            color: COLORS.apariLightBlue,
            marginTop: '-7.5px'
        }
    },
    input: {
        width: 70,
        textAlign: 'center'
    }
}));
